export const MAX_DAYS_TO_SHOW_RELATIVE_DATE = 14;
export const DATE_FORMAT = 'MMM D, YYYY';
export const TIMESTAMP_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ[Z]';
